import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { interval, Subject, takeUntil } from 'rxjs';
import { PdfJob, PdfJobStatus } from 'src/app/models/pdf-job.interface';

/**
 * Component for a progress indicator for a currently running pdf job.
 */
@Component({
    selector: 'app-pdf-progress',
    templateUrl: './pdf-progress.component.html',
    styleUrls: ['./pdf-progress.component.scss'],
    standalone: false,
})
export class PdfProgressComponent implements OnInit, OnDestroy {
    /**
     * The PDF job
     */
    @Input() job!: PdfJob;

    progress = 0;

    private readonly destroy = new Subject<void>();

    ngOnInit(): void {
        if (this.job.status === PdfJobStatus.PROCESSING) {
            interval(2000)
                .pipe(takeUntil(this.destroy))
                .subscribe(() => {
                    this.progress += 5;
                    if (this.progress >= 95) {
                        this.destroy.next();
                    }
                });
        }
    }

    ngOnDestroy(): void {
        this.destroy.next();
        this.destroy.complete();
    }
}
